module.exports = __webpack_public_path__ + "static/media/photo-3.9246a01b.jpg";